// const API_BASE_URL = "http://localhost:5001/api/register"; // Ensure this matches your backend

// export const completeProfile = async (formData) => {
//   const url = `${API_BASE_URL}/alumni`; // Fix: Corrected endpoint

//   try {
//     console.log("📤 [DEBUG] Sending profile data to:", url);

//     const response = await fetch(url, {
//       method: "POST",
//       body: formData,
//     });

//     if (!response.ok) {
//       const errorResponse = await response.text();
//       console.error("❌ [ERROR] Response:", errorResponse);
//       throw new Error(errorResponse || "Profile submission failed");
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("❌ [ERROR] Error submitting profile:", error);
//     throw error;
//   }
// };

const API_BASE_URL = "https://dynamic-reg-validation-service-51hl.onrender.com/api/register"; // ✅ Ensure correct backend URL

export const completeProfile = async (formData) => {
  const url = `${API_BASE_URL}/register/alumni`;  // Ensure this matches backend // ✅ Fix: Corrected endpoint

  try {
    console.log("📤 [DEBUG] Sending profile data to:", url);

    const response = await fetch(url, {
      method: "POST",
      body: formData, // ✅ FormData automatically sets correct Content-Type
    });

    // ✅ Handle Errors
    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ [ERROR] Server Response:", errorText);
      throw new Error(errorText || "Profile submission failed");
    }

    // ✅ Parse Response as JSON
    const data = await response.json();
    console.log("✅ [SUCCESS] Profile submitted:", data);
    return data;
  } catch (error) {
    console.error("❌ [ERROR] Error submitting profile:", error.message);
    throw error;
  }
};
